import { render, staticRenderFns } from "./RefundInstruction.vue?vue&type=template&id=6f6b0b49&scoped=true&"
import script from "./RefundInstruction.vue?vue&type=script&lang=js&"
export * from "./RefundInstruction.vue?vue&type=script&lang=js&"
import style0 from "./RefundInstruction.vue?vue&type=style&index=0&id=6f6b0b49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b0b49",
  null
  
)

export default component.exports